<div class="popover" [ngClass]="{ 'fixed-height-container': this.searchWithApi }">
  <div *ngIf="popoverHeader" class="popover-header">{{ popoverHeader | translate }}</div>
  <div
    *ngIf="this.searchWithApi === undefined; else searchWithAPI"
    class="search-container"
    [ngClass]="{ 'search-container--modal': popoverRenderOptionType === 'MODAL' }"
  >
    <ion-searchbar
      [placeholder]="searchPlaceholderForLocalSerach"
      mode="ios"
      color="light"
      (ionChange)="onSearch($event)"
    ></ion-searchbar>
  </div>
  <ng-template #searchWithAPI>
    <monorepo-searchbar-with-api-suggestions-container
      *ngIf="this.searchWithApi"
      [placeholder]="searchPlaceholder"
      [searchAPIResults]="searchAPIResults"
      (searchEvent)="triggerApiSearch($event)"
      (applySearchResultSelect)="applySearchResultSelect($event)"
    >
    </monorepo-searchbar-with-api-suggestions-container>
  </ng-template>

  <ng-template #labelWithCheckbox let-option="option">
    <ion-item>
      <ion-checkbox
        [(ngModel)]="option.isSelected"
        [mode]="popoverRenderOptionType === 'INLINE' ? 'ios' : 'md'"
        [ngClass]="{ modal: popoverRenderOptionType === 'MODAL' }"
        (ngModelChange)="onChange()"
      ></ion-checkbox>
      <ion-label
        class="multi-select__label"
        [ngClass]="{ 'multi-select__label--modal': popoverRenderOptionType === 'MODAL' }"
      >
        {{ option.displayText ? (option.displayText | translate) : option.value }}
      </ion-label>
    </ion-item>
  </ng-template>
  <ion-grid class="multi-select">
    <div
      class="multi-select__option-container"
      [ngClass]="{
        'multi-select__option-container--modal': popoverRenderOptionType === 'MODAL',
        'multi-select__option-container--height': popoverRenderOptionType === 'MODAL'
      }"
    >
      <!-- For inline mode, min-height of 300px is required to prevent viewport from collapsing -->
      <ng-container *ngIf="virtualScroll; else normalContentLoad">
        <cdk-virtual-scroll-viewport
          [itemSize]="virtualScroll.itemSize"
          [minBufferPx]="virtualScroll.minBufferPx"
          [maxBufferPx]="virtualScroll.maxBufferPx"
          [ngStyle]="{ 'min-height': popoverRenderOptionType === 'INLINE' ? '300px' : 'undefined' }"
        >
          <ng-container *cdkVirtualFor="let option of filteredPopoverInfo; let i = index; trackBy: trackByFn">
            <ng-container *ngTemplateOutlet="labelWithCheckbox; context: { option: option }"></ng-container>
          </ng-container>
        </cdk-virtual-scroll-viewport>
      </ng-container>

      <ng-template #normalContentLoad>
        <ng-container *ngFor="let option of filteredPopoverInfo; let i = index">
          <ng-container *ngTemplateOutlet="labelWithCheckbox; context: { option: option }"></ng-container>
        </ng-container>
      </ng-template>
    </div>
  </ion-grid>
  <div *ngIf="popoverRenderOptionType !== 'TABS'">
    <ion-row class="multi-select__button-container">
      <ion-col *ngIf="showClose" size="6" class="multi-select__close">
        <ui-custom-button
          [btnTxt]="'multi_select.Close' | translate"
          [buttonType]="'SECONDARY'"
          (clickEvent)="onClose()"
          [expand]="'block'"
        ></ui-custom-button>
      </ion-col>
      <ion-col>
        <ui-custom-button
          [btnTxt]="(popoverBtnText ? popoverBtnText : 'multi_select.Apply') | translate"
          [buttonType]="'PRIMARY'"
          (clickEvent)="onApply(_popoverInfo)"
          [expand]="'block'"
        ></ui-custom-button>
      </ion-col>
    </ion-row>
  </div>
</div>
